import { z } from "zod";

export const callHistoryFilterSchema = z.object({
	disposition: z
		.enum(["resolved", "escalated", "info-only", "wrong-number", "other"])
		.optional(),
	from: z
		.string()
		.default(() =>
			new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()
		),
	to: z.string().default(() => new Date().toISOString()),
	closedBy: z.string().uuid().optional(),
	page: z.number().int().min(0).default(0),
	pageSize: z.number().int().min(10).max(100).default(25),
	callId: z.string().uuid().optional(),
});

export type CallHistoryFilters = z.infer<typeof callHistoryFilterSchema>;
